import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Import Sentry
import * as Sentry from "@sentry/angular";
import { BrowserTracing } from "@sentry/tracing";

Sentry.init({
  dsn: "https://4cd3f476f6274c7faa45817e2e0d863a@o1420777.ingest.sentry.io/6765939",
  integrations: [
    // new BrowserTracing({
    //   tracingOrigins: ["localhost", "https://yourserver.io/api"],
    //   routingInstrumentation: Sentry.routingInstrumentation,
    // }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
